import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { hasRole } from "@/lib/roles";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-viva-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  // Force password change if flagged (except when already on change-password page)
  if (user.must_change_password && location.pathname !== "/cambio-password") {
    return <Navigate to="/cambio-password" replace />;
  }
  if (roles && !hasRole(user, ...roles)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-md text-center" data-testid="forbidden-screen">
          <h1 className="text-3xl font-heading font-bold text-slate-900 mb-2">Accesso negato</h1>
          <p className="text-slate-600">Il tuo ruolo non ha i permessi per questa pagina.</p>
        </div>
      </div>
    );
  }
  return children;
}
